import React from 'react';
import FilterNotificationForm from './FilterFormNotification';

const SearchFilterNotification = ({
  onClick,
  modalActive,
  filter,
  setFilter
}) => (
  <FilterNotificationForm
    onClick={onClick}
    modalActive={modalActive}
    filter={filter}
    setFilter={setFilter}
  />
);

export default SearchFilterNotification;
